import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import {
  GameDetailsTopMessages,
  GameDetailsTopPropTypes,
} from '../GameDetailsTop';
import GameDetailsTopInfoFeatures from './GameDetailsTopInfoFeatures';
import GameDetailsTopInfoTable from './GameDetailsTopInfoTable';
import GameDetailsTopLink from '../GameDetailsTopLink/GameDetailsTopLink';

interface GameDetailsTopInfoPropTypes {
  game: GameTileProps;
  staticTexts: GameDetailsTopMessages;
  pageTitle?: string;
  onGameButtonClick: GameDetailsTopPropTypes['onGameButtonClick'];
}

const GameDetailsTopInfo: React.FC<GameDetailsTopInfoPropTypes> = React.memo(
  ({ game, staticTexts, pageTitle, onGameButtonClick }) => {
    return (
      <div
        className={cx(
          game.infoPageImages
            ? styles.gameInfoWrapper
            : styles.gameInfoWrapperSimple
        )}
      >
        <div className={cx(styles.gameInfoDetails)}>
          <p
            data-testid="game-details-header-game-type"
            className={cx(
              styles.type,
              !game.infoPageImages && styles.typeFallbackColor
            )}
          >
            {game.type}
          </p>
          <p
            data-testid="game-details-header-game-title"
            className={cx(
              styles.title,
              game.infoPageImages ? styles.titleBig : styles.titleSmall
            )}
          >
            {game.title}
          </p>
          {game.infoPageImages && game.features && (
            <GameDetailsTopInfoFeatures game={game} staticTexts={staticTexts} />
          )}
          <GameDetailsTopInfoTable game={game} staticTexts={staticTexts} />
        </div>

        <GameDetailsTopLink
          game={game}
          staticTexts={staticTexts}
          pageTitle={pageTitle}
          onGameButtonClick={onGameButtonClick}
        />
      </div>
    );
  },
  (
    prevProps: GameDetailsTopInfoPropTypes,
    nextProps: GameDetailsTopInfoPropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsTopInfo;
